export default "__VITE_ASSET__CDIiufrX__"